
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M11.6 9.59997L12.63 8.56996C13.0044 8.20455 13.5068 8 14.03 8C14.5532 8 15.0556 8.20455 15.43 8.56996V8.56996C15.7954 8.94437 16 9.44681 16 9.96998C16 10.4931 15.7954 10.9956 15.43 11.37L14.4 12.4"></path><path d="M12.4 14.4L11.37 15.43C10.9956 15.7954 10.4931 16 9.96998 16C9.44681 16 8.94437 15.7954 8.56996 15.43V15.43C8.20455 15.0556 8 14.5532 8 14.03C8 13.5068 8.20455 13.0044 8.56996 12.63L9.59997 11.6"></path><path d="M10.4 13.6001L13.6 10.4"></path><path d="M3 3H21V21H12H3V12V3Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiIFrame",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
